import { hexToRgb } from './hex-to-rgb.util';
import { rgbToHex } from './rgb-to-hex.util';

const lerp = (a: number, b: number, t: number): number => a + (b - a) * t;

export const lerpColor = (from: string, to: string, t: number): string => {
  const clamped = Math.min(1, Math.max(0, t));
  const [r1, g1, b1] = hexToRgb(from);
  const [r2, g2, b2] = hexToRgb(to);
  return rgbToHex(
    lerp(r1, r2, clamped),
    lerp(g1, g2, clamped),
    lerp(b1, b2, clamped),
  );
};
